const FormSelect = ({
  label,
  name,
  placeholder,
  options,
  value,
  onChange,
  className,
  required,
}) => {
  return (
    <>
      <label className="form-label">{label}</label>
      <select
        name={name}
        className={`form-control ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e)}
        required={required}
      >
        {options?.map((option, index) => <option key={index} value={option.value}>{option.label}</option>)}
      </select>
    </>
  );
};

export default FormSelect;
